import { createContext } from "react";

export const FieldContext = createContext<{
  id?: string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
}>({});
